import { render } from "./routerlogin.vue?vue&type=template&id=596905ca"
import script from "./routerlogin.vue?vue&type=script&lang=js"
export * from "./routerlogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__